import {
  Flex,
  FormLabel,
  Input,
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Select,
  Button,
  useToast
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { FormLeadService } from '../../../services/FormLead/FormLeadService'
import { IFormLead, IFormLeadStatus, statusTranslations } from './models'

interface IProps {
  isOpen: boolean
  onClose: () => void
  lead: IFormLead | null
  sellers: string[]
}

export function FormLeadsEditModal({ isOpen, onClose, lead, sellers }: IProps) {
  const service = new FormLeadService()
  const toast = useToast()
  const [areas, setAreas] = useState<string[]>([])
  const [courses, setCourses] = useState<string[]>([])
  const [form, setForm] = useState<IFormLead>({
    id: 0,
    name: '',
    email: '',
    phone: '',
    format: '',
    area: '',
    course: '',
    source: '',
    seller_name: '',
    status: 'Sem Contato',
    utm_campaign: '',
    utm_source: '',
    utm_medium: '',
    utm_content: '',
    utm_term: '',
    created_at: ''
  })

  const loadAreas = async () => {
    setAreas(await service.getAreas(form.format))
  }

  const loadCourses = async () => {
    setCourses(await service.getCourses(form.area))
  }

  const handleSave = async (event: React.FormEvent) => {
    event.preventDefault()

    service
      .update(form.id, form)
      .then(() => {
        toast({
          title: 'Registro atualizado com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true
        })

        onClose()
      })
      .catch(() => {
        toast({
          title: 'Erro ao atualizar registro',
          status: 'error',
          duration: 3000,
          isClosable: true
        })
      })
  }

  useEffect(() => {
    if (lead) {
      setForm({ ...lead, format: lead.format.toLowerCase() })
    }
  }, [lead])

  useEffect(() => {
    loadAreas()
  }, [form.format])

  useEffect(() => {
    loadCourses()
  }, [form.area])

  return (
    lead && (
      <>
        <ChakraModal isOpen={isOpen} onClose={onClose} size="3xl" isCentered scrollBehavior="inside">
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Contato via formulário</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex direction="column">
                <FormLabel>Nome</FormLabel>
                <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required />
                <FormLabel mt={4}>E-mail</FormLabel>
                <Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
                <FormLabel mt={4}>Telefone</FormLabel>
                <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                <FormLabel mt={4}>Status</FormLabel>
                <Select
                  value={form.status}
                  onChange={(e) => setForm({ ...form, status: e.target.value as IFormLeadStatus })}
                >
                  <option value="Sem Contato">{statusTranslations['Sem Contato']}</option>
                  <option value="Qualificado">{statusTranslations.Qualificado}</option>
                  <option value="Desqualificado">{statusTranslations.Desqualificado}</option>
                </Select>
                <FormLabel mt={4}>Formato</FormLabel>
                <Select value={form.format} onChange={(e) => setForm({ ...form, format: e.target.value })}>
                  <option value="online">Online</option>
                  <option value="online ao vivo">Online Ao Vivo</option>
                  <option value="presencial">Presencial</option>
                </Select>
                <FormLabel mt={4}>Área</FormLabel>
                <Select value={form.area} onChange={(e) => setForm({ ...form, area: e.target.value })}>
                  {areas.map((area) => (
                    <option key={area} value={area}>
                      {area}
                    </option>
                  ))}
                </Select>
                <FormLabel mt={4}>Curso</FormLabel>
                <Select value={form.course} onChange={(e) => setForm({ ...form, course: e.target.value })}>
                  {courses.map((course) => (
                    <option key={course} value={course}>
                      {course}
                    </option>
                  ))}
                </Select>
                <FormLabel mt={4}>Origem</FormLabel>
                <Select value={form.source} onChange={(e) => setForm({ ...form, source: e.target.value })}>
                  <option value="Eventos">Eventos</option>
                  <option value="Presencial">Presencial</option>
                  <option value="Redes Sociais">Redes Sociais</option>
                  <option value="Site">Site</option>
                  <option value="Site (quero ser aluno)">Site (quero ser aluno)</option>
                  <option value="Site - Compre Aqui">Site - Compre Aqui</option>
                  <option value="Telefone">Telefone</option>
                </Select>
                <FormLabel mt={4}>Responsável</FormLabel>
                <Select value={form.seller_name} onChange={(e) => setForm({ ...form, seller_name: e.target.value })}>
                  {sellers.map((seller) => (
                    <option key={seller} value={seller}>
                      {seller}
                    </option>
                  ))}
                </Select>
                <FormLabel mt={4}>UTM Campaign</FormLabel>
                <Input value={form.utm_campaign} readOnly />
                <FormLabel mt={4}>UTM Source</FormLabel>
                <Input value={form.utm_source} readOnly />
                <FormLabel mt={4}>UTM Medium</FormLabel>
                <Input value={form.utm_medium} readOnly />
                <FormLabel mt={4}>UTM Content</FormLabel>
                <Input value={form.utm_content} readOnly />
                <FormLabel mt={4}>UTM Term</FormLabel>
                <Input value={form.utm_term} readOnly />
              </Flex>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="magenta" mr={3} onClick={handleSave} type="submit">
                Salvar
              </Button>
              <Button variant="ghost" onClick={onClose} type="button">
                Cancelar
              </Button>
            </ModalFooter>
          </ModalContent>
        </ChakraModal>
      </>
    )
  )
}
